import { customEvent } from "src/utils/gtag.js";

export const PRINTABLE_SCHEDULE_MAX_BYTES = 10 * 1024 * 1024;
export const PRINTABLE_SCHEDULE_CATEGORY = "PrintableSchedule";

/**
 * Sends a printable-schedule GA event with the standard user + calendar payload.
 * @param {{ name: string, label: string, user?: object, calendar?: object, surface: string, action?: string }} params
 * @returns {void}
 */
export function trackPrintableScheduleEvent({ name, label, user, calendar, surface, action = "click" }) {
  customEvent({
    name,
    label,
    category: PRINTABLE_SCHEDULE_CATEGORY,
    action,
    data: {
      user_id: user?._id,
      user_email: user?.email,
      calendar_id: calendar?._id ? String(calendar._id) : undefined,
      calendar_handle: calendar?.handle,
      calendar_name: calendar?.name,
      surface,
    },
  });
}

/**
 * Checks a picked file against the upload rules before it is sent.
 * @param {File | undefined} file
 * @returns {string | null} A user-facing error, or null when the file is acceptable.
 */
export function validatePrintableScheduleFile(file) {
  if (!file) return "Choose a PDF to upload.";
  const isPdf = file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
  if (!isPdf) return "Only PDF files are accepted.";
  if (file.size > PRINTABLE_SCHEDULE_MAX_BYTES) return "The PDF must be 10 MB or smaller.";
  return null;
}
